// extracted by mini-css-extract-plugin
export var closeButton = "_fi-2";
export var closeButtonIcon = "_fi-3";
export var lightboxContent = "_fi-1";
export var lightboxOverlay = "_fi-0";